import {
  WidgetConfig,
  WidgetDataDependencies,
  WidgetStrategy,
} from '../../types/widget-manager.types';

/**
 * Abstract base widget strategy
 * Defines the contract for all widget strategies
 */
export abstract class BaseWidgetStrategy implements WidgetStrategy {
  /**
   * Get widget configurations for this strategy
   * @param data - Widget data dependencies
   * @returns Array of widget configurations
   */
  abstract getWidgetConfigs(data: WidgetDataDependencies): WidgetConfig[];

  /**
   * Validate widget data dependencies
   * @param data - Widget data dependencies
   * @returns True if data is valid, false otherwise
   */
  protected validateData(data: WidgetDataDependencies): boolean {
    return data !== null && data !== undefined;
  }

  /**
   * Filter out invalid widget configs
   * @param configs - Widget configurations to filter
   * @returns Valid widget configurations
   */
  protected filterValidConfigs(configs: WidgetConfig[]): WidgetConfig[] {
    return configs.filter((config) => {
      if (!config || !config.type) {
        return false;
      }
      // Filter out disabled widgets
      if (config.enabled === false) {
        return false;
      }
      return true;
    });
  }
}
